module.exports = __webpack_public_path__ + "static/media/sale.e8b624bb.png";